import { Steps, Button } from 'antd';
import { AddingImages, AddingInfo, AddingVideo, Layout } from '../../components';

import { useState } from 'react';
import styles from './CocktailsAddingPage.module.scss';
import { ICoctail } from '@/types';
import { initialCoctailValue } from './config';

const CocktailsAddingPage = ({ logOut }: { logOut: () => void }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [coctail, setCoctail] = useState<ICoctail>(initialCoctailValue);
  const [disabledImageStep, setDisabledImageStep] = useState<boolean>(true);
  const [disabledVideoStep, setDisabledVideoStep] = useState<boolean>(true);

  const onToggleDisabledImageStep = (value: boolean) => setDisabledImageStep(value);
  const onToggleDisabledVideoStep = (value: boolean) => setDisabledVideoStep(value);

  const contentStyle = {
    marginTop: 24,
  };

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const steps = [
    {
      title: 'Image',
      content: (
        <AddingImages
          action={'add'}
          setCoctail={setCoctail}
          coctail={coctail}
          onToggleDisabled={onToggleDisabledImageStep}
        />
      ),
    },
    {
      title: 'Video',
      content: (
        <AddingVideo
          action="add"
          setCoctail={setCoctail}
          coctail={coctail}
          onToggleDisabled={onToggleDisabledVideoStep}
        />
      ),
    },
    {
      title: 'Information',
      content: <AddingInfo coctail={coctail} setCoctail={setCoctail} action={'add'} />,
    },
  ];

  const stepsList = steps.map(item => ({
    key: item.title,
    title: item.title,
  }));

  return (
    <Layout title={'Adding a cocktail'} logOut={logOut}>
      <>
        <Steps current={currentStep} items={stepsList} />
        <div className={styles.actions}>
          {currentStep > 0 && (
            <Button onClick={prevStep}>
              Previous step
            </Button>
          )}
          {currentStep < steps.length - 1 && (
            <Button type="primary" onClick={nextStep} disabled={currentStep > 0 ? disabledVideoStep : disabledImageStep}>
              Next step
            </Button>
          )}
        </div>

        <div style={contentStyle}>{steps[currentStep].content}</div>
      </>
    </Layout>
  );
};

export default CocktailsAddingPage;
